import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { fromJS, List, Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import TimelineFilterTeams from './TimelineFilterTeams';
import TimelineFilterOwners from './TimelineFilterOwners';
import TimelineClearFiltersButton from './TimelineClearFiltersButton';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { useStoreDependency } from 'general-store';
import { TimelineOwnersFilterDependency, TimelineTeamsFilterDependency, useTeamFilter, useUserFilter, TimelineActions } from 'crm-events-data';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TEAMS = 'TEAMS';
const USERS = 'USERS';
const propTypes = {
  error: PropTypes.object,
  objectType: AnyCrmObjectTypePropType.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  subjectId: PropTypes.string.isRequired,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof List' is not assignable t... Remove this comment to see the full error message
  timelineFavoriteEvents: PropTypes.instanceOf(List)
};
const TimelineAdvancedFiltersV2 = ({
  error,
  objectType,
  onResetFilters,
  subjectId,
  timelineFavoriteEvents
}) => {
  const [isTeamFilterOpen, openTeamFilter, closeTeamFilter] = useTeamFilter();
  const [isUserFilterOpen, openUserFilter, closeUserFilter] = useUserFilter();
  const selectedTeams = useStoreDependency(TimelineTeamsFilterDependency, {
    objectType
  });
  const selectedOwners = useStoreDependency(TimelineOwnersFilterDependency, {
    objectType
  });
  const handleUpdateTimelineUserAndTeamFilters = useCallback((filterType, selectedIds) => {
    const updatedFilters = ImmutableMap({
      selectedTeams: filterType === TEAMS ? selectedIds : selectedTeams,
      selectedOwners: filterType === USERS ? selectedIds : selectedOwners
    });
    const requestPayload = ImmutableMap({
      eventOptions: timelineFavoriteEvents,
      objectType,
      subjectId
    }).merge(updatedFilters);
    TimelineActions.updateTimelineUserAndTeamFilters(objectType, requestPayload);
  }, [selectedOwners, selectedTeams, timelineFavoriteEvents, objectType, subjectId]);
  const handleUserOpenChange = useCallback(({
    target: {
      value
    }
  }) => {
    return value ? openUserFilter() : closeUserFilter();
  }, [openUserFilter, closeUserFilter]);
  const handleUserChange = useCallback(value => {
    const subAction = value.length > selectedOwners.size ? 'added' : 'removed';
    CrmLogger.logRecordInteraction(objectType, {
      action: 'filter timeline by user',
      subAction
    });
    CrmLogger.log('timelineInteractions', {
      action: 'filter',
      subAction,
      filterType: 'by user'
    });
    handleUpdateTimelineUserAndTeamFilters(USERS, fromJS(value));
  }, [handleUpdateTimelineUserAndTeamFilters, selectedOwners, objectType]);
  const handleTeamOpenChange = useCallback(({
    target: {
      value
    }
  }) => {
    return value ? openTeamFilter() : closeTeamFilter();
  }, [openTeamFilter, closeTeamFilter]);
  const handleTeamChange = useCallback(({
    target: {
      value
    }
  }) => {
    const subAction = value.size > selectedTeams.size ? 'added' : 'removed';
    CrmLogger.logRecordInteraction(objectType, {
      action: 'filter timeline by team',
      subAction
    });
    CrmLogger.log('timelineInteractions', {
      action: 'filter',
      subAction,
      filterType: 'by team'
    });
    handleUpdateTimelineUserAndTeamFilters(TEAMS, value);
  }, [selectedTeams, handleUpdateTimelineUserAndTeamFilters, objectType]);
  if (error) {
    return null;
  }
  const shouldRenderClearFiltersButton = Boolean(selectedTeams.size || selectedOwners.size);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    "data-test-id": "advanced-filters",
    children: [/*#__PURE__*/_jsx(TimelineFilterOwners, {
      handleUserOpenChange: handleUserOpenChange,
      isUserFilterOpen: isUserFilterOpen,
      onChange: handleUserChange,
      value: selectedOwners
    }), /*#__PURE__*/_jsx(TimelineFilterTeams, {
      handleTeamOpenChange: handleTeamOpenChange,
      isTeamFilterOpen: isTeamFilterOpen,
      onChange: handleTeamChange,
      value: selectedTeams
    }), shouldRenderClearFiltersButton && /*#__PURE__*/_jsx(TimelineClearFiltersButton, {
      onResetFilters: onResetFilters
    })]
  });
};
TimelineAdvancedFiltersV2.propTypes = propTypes;
export default TimelineAdvancedFiltersV2;